

// jQuery.noConflict();
//  (function(j) {
//     // code using j as alias to jQuery
// })(jQuery);


(function ($) {

  // Amenities on search
  var amenitiesBox = $('.eltd-listing-archive-amenities-holder');
  var amenitiesAction = $('.amenities-action');

  amenitiesBox.css('display', 'none'); // Hide the box by default

  $(amenitiesAction).click(function () {
    $(amenitiesBox).slideToggle('slow');
    if (amenitiesAction.text() == "Show") {
      amenitiesAction.text("Hide");
      amenitiesAction.removeClass('rotate');
    }
    else {
      amenitiesAction.text("Show");
      amenitiesAction.addClass('rotate');
    }
  });
  // $amenitiesBox.css( "border", "3px solid red" );
  // console.log($amenitiesBox);


  // Start Owl Gallery
  var owlImgSrc;
  $('.item img').each(function (index) {
    owlImgSrc = $(this).attr('src');
    $(this).parent('.item').css({ 'background-image': 'url(' + owlImgSrc + ')', 'background-size': 'cover', 'height': '350px' });
    $(this).css('visibility', 'hidden');
  });
  $(".owl-carousel").owlCarousel({
    margin: 5,
    loop: true,
    items: 3,
    autoplay: true,
    responsive: {
      0: {
        items: 1,
        // nav:true
      },
      600: {
        items: 2,
        // nav:false
      },
      780: {
        items: 3,
        // nav:true,
        // loop:false
      }
    }
  });

})(jQuery);
